<template>
    <div class="page-setting biz-elect-receipt parent-frame" :class="{'fixed': listIsFixed}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <!-- <button class="default-button publish">下載</button> -->
            </div>
        </div>
        <elect-receipt-comp></elect-receipt-comp>
    </div>
</template>
<script>
import electReceiptComp from '@/components/bussiness/settingCenter/electReceipt/electReceiptComp.vue';

export default {
    data () {
        return {
            listIsFixed: false,
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    components: {
        electReceiptComp
    }
}
</script>
<style lang="scss">
    .biz-elect-receipt{
        // .insert{
        //     width: 120px;
        // }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/settingCenter/electReceipt/electReceiptDefault.vue